const formMappings = {
    "AIA-01": "Declaration",
    "AIA-02": "Sub_Statement",
    "AIA-03": "Declaration_Plant_ADS",
    "AIA-04": "Sub_Statement_PlantPatent",
    "AIA-05": "ReissueAppl_Declaration_Inventor",
    "AIA-06": "ReissueAppl_Declaration_Assignee",
    "AIA-07": "Sub_Statement_ReissuePatent",
    "AIA-08": "Declaration _Utility_Patent_CFR",
    "AIA-09": "Declaration_Plant",
    "AIA-10": "Supp_Declaration",
    "AIA-11": "Sub_Statement_SuppSheet",
    "AIA-122": "Change_Application_CorrespondenceAddress",
    "AIA-123": "Change_Patent_CorrespondenceAddress",
    "AIA-14": "ADS",
    "AIA-15": "Transmittal",
    "AIA-17p": "Transmittal_PetitionFee",
    "AIA-18": "Design_Transmittal",
    "AIA-19": "Plant_Application_Transmittal",
    "AIA-22": "EOT",
    "AIA-24": "ExpressAban",
    "AIA-24A": "Petition_ExpressAbandonment_AvoidPublication",
    "AIA-24B": "Petition_ExpressAbandonment_ObtainRefund",
    "AIA-25": "TD_Provisional_Rejection_Pending",
    "AIA-26": "TD_Double_PatentRejection_Over_Patent",
    "AIA-31": "NOTICE_OF_APPEAL",
    "AIA-32": "REQUEST_ORAL_HEARING",
    "AIA-33": "PRE-APPEAL_BRIEF_REQUEST",
    "AIA-34": "TRANSMITTAL_APPEAL_FORWARDING_FEE",
    "AIA-40": "Request to correct Inventroship",
    "AIA-41": "Request to update Applicant",
    "AIA-424": "Track_One_Request_Form",
    "AIA-440": "Certification_ProBono_Representation",
    "AIA-47": "FeeAddr_Indication",
    "AIA-50": "Reissue_Application_Transmittal",
    "AIA-53": "ReissueAppl_Consent_Statement_Assignment",
    "AIA-63": "TD_Design",
    "AIA-67": "Inspect_Applications",
    "AIA-80": "POA",
    "AIA-81": "POA_And_Change_Correspondence_Address",
    "AIA-81a": "POA_Change_OR_Revocation",
    "AIA-81B": "Reexam_SupplExam_POA_New_Change_Address",
    "AIA-82": "POA",
    "AIA-83": "Request for Withdrawal ",
    "AIA-96": "Statement Under 37 CFR 3.73(c)",
    "PTO-1382": "Transmittal_Letter_RO-US",
    "PTO-1390": "Transmittal",
    "PTO-2326": "Request for Refund",
    "PTO-437-KR": "CombinedPeti_to_Under_Collaborative_Program_USPTO_KIPO",
    "PTO-437-JP": "CombinedPeti_to_Under_Collaborative_Program_USPTO_JPO",
    "PTOL-413A": "Appl_Initiated_Interview_Request_Form",
    "SB-06": "PatentAppl_Fee",
    "SB-07": "MultipleDepe_Claim_Sheet",
    "SB-08": "IDS",
    "SB-09": "QPIDS",
    "SB-124": "Request_Customer_Number_Change",
    "SB-125": "Request_Customer_Number",
    "SB-130": "Petition to Make Special Based on Age-Health",
    "SB-133": "PTA_Filed_with_IDS",
    "SB-134": "Request_Recalculation_PTA",
    "SB-15A": "Certificate_of_Micro_Entity_GIB",
    "SB-15B": "Certificate_of_Micro_Entity_Institution_Education",
    "SB-16": "Provisional Coversheet",
    "SB-17": "Fee_Transmittal",
    "SB-17i": "Processing_Fee_Transmittal",
    "SB-21": "TransmittalForm",
    "SB-23": "PetitionExte_Time_Under_37CFR1.136b",
    "SB-25a": "TD_Patent_ Proceeding_view_an_Application",
    "SB-26a": "TM_PatentorProceeding_view_Another_Patent",
    "SB-27": "Design _Request_Expedited_Examination",
    "SB-28": "PetitionSake_Make_Accelerated",
    "SB-29": "CONTINUEDS AP_APPLICATION",
    "SB-30": "RCE",
    "SB-30(1)": "RequestSont_Continued_Transmittal",
    "SB-35": "Nonpublication Request",
    "SB-36": "RescissionSrev_Previous",
    "SB-37": "RequestSefe_Deferral_CFR_103",
    "SB-38": "RequestSetr_Retrieve_Application",
    "SB-39": "AuthorizationSerm_Permit_Application",
    "SB-429": "ThirdSart_Submission_instructions",
    "SB-434": "CertificationSequ_Request_under_Final_Program",
    "SB-437": "PetitionSake_Make_the_Search",
    "SB-439": "Internet Comm Authorized",
    "SB-44": "CertificateSorr_Correction",
    "SB-443": "CertificationSeti_Petition_Special_Cancer_Program",
    "SB-448": "CertificationSequ_Request_an_During_Significant_Business",
    "SB-450": "CertificationSequ_Request_Prioritized_Program_e",
    "SB-451": "PETITIONSast_Track_Program",
    "SB-453": "CertificationSequ_Request_the_CFR_g_of_Copy_the_the_Outbreak",
    "SB-454": "PetitionSast_Track_Related_Program",
    "SB-457": "CertificationSeti_Petition_Special_Climate_Pilot",
    "SB-458": "PetitionScce_Accept_Delayed_U_a_f_b_b_a",
    "SB-459": "PetitionSest_Restore_of_Application_or_the_a_CFR_37_55",
    "SB-460": "NotificationSoss_Loss_Entity",
    "SB-56": "ReissueSppl_Fee",
    "SB-57": "RequestSx P_Ex_Transmittal",
    "SB-59": "RequestSor _Supplemental_Form",
    "SB-64": "PetitionSevi_Revival_Application_Abandoned",
    "SB-64PCT": "PCTSeti_for_an_for_the_Abandoned_CFR_a",
    "SB-66": "PetitionScce_Accept_Payment_Fee_Expired",
    "SB-68": "RequestScce_Access_Abandoned_CFR",
    "SB-69": "AuthorizationSesc_Rescission_to_to_by_Patent",
    "SB-81C": "CSeex_Third_POA_of_a_and_Correspondence",
    "SB-92": "CertificateSail_Mailing",
    "PTO-1595": "RECORDATIONP_CO_COVER",
    "SB-08b": "bSisc_Disclosure_Applicant",
    "SB-43": "DisclaimerSate_a_CFR_321",
    "SB-64a": "aSevi_for_an_Patent_Failure_International",
    "SB-445": "PetitionScce_Accept_Delayed_U_C",
    "SB-464": "CertificationSeti_Petition_First_Expedited_Program",
    "SB-465": "CertificationSeti_Petition_Special_Cancer_Examination",
    "SB-467": "CertificationSeti_Petition_Special_Semiconductor_Program"
  };

  export default formMappings;